import { render, staticRenderFns } from "./CompanySetting.vue?vue&type=template&id=2ef53da1&scoped=true&"
import script from "./CompanySetting.vue?vue&type=script&lang=js&"
export * from "./CompanySetting.vue?vue&type=script&lang=js&"
import style0 from "./CompanySetting.vue?vue&type=style&index=0&id=2ef53da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef53da1",
  null
  
)

export default component.exports